import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { PageLayout, PageSize } from "@/components";
import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Col, Row } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import PersonaForm from "@/components/Personas/PersonaForm/PersonaForm";
import Trans from "@/components/Trans/Trans";
import { EXTERNAL_ROUTES_FOR_APPLICATION } from "@/constants";

export default function PersonaCreate() {
  const applicationId = basicAppConfig.applicationId;

  return (
    <PageLayout size={PageSize.Medium}>
      <PageStaticMetaTags pageId="createPersona" />
      <Col className="bg-gray-3 rounded-lg p-md md:p-lg mt-4 md:mt-0">
        <Col className="grow gap-lg">
          <Col>
            <Row className="justify-between items-center">
              <Text variant={TextVariants.HEADING_5_BOLD}>
                <Trans i18nKey="personas:page.createPersona.title" />
              </Text>
              <LocalizedLink
                to={EXTERNAL_ROUTES_FOR_APPLICATION[applicationId as keyof typeof EXTERNAL_ROUTES_FOR_APPLICATION]?.persona_creation_guide}
                target="_blank"
                aria-label="creation-guide"
                className="text-blue-10"
              >
                <Text>
                  <Trans i18nKey="common:creationGuide" />
                </Text>
              </LocalizedLink>
            </Row>
          </Col>
          <PersonaForm />
        </Col>
      </Col>
    </PageLayout>
  );
}
